import type { Release } from '../releases';

export default {
  id: '2026-11-01-help-pilot',
  at: '2026-11-01T05:34:00Z',
  title: 'Вопрос Pilot в «Помощи»',
  modules: [],
  items: [
    'В панели «Помощь» на любой странице можно спросить Pilot, как работать в портале. Pilot отвечает по инструкции к этой странице для вашей роли и по статьям базы знаний, которые вам открыты, и даёт ссылки на них. Ответ помечен «Подготовлено ИИ»; если ответа в инструкциях нет, Pilot так и скажет.',
    'Помогло — нажмите «Помогло», вопрос закроется без поддержки. Не помогло — «В поддержку»: обращение уйдёт вместе с перепиской, отвечать будет человек.',
    'Поле вопроса появляется, когда в портале подключена проверенная модель Pilot и в вашей роли есть право «Пользоваться ИИ-помощником».',
  ],
  why: 'Чтобы узнать, как что-то сделать в портале, приходилось читать инструкцию целиком или ждать ответа поддержки. Теперь на простой вопрос можно сразу получить ответ со ссылкой на инструкцию.',
  link: '/support',
} satisfies Release;
